<template>
  <div id="imp-count" ref="impCount">
    <div class="gridchild grida">
      <header>
        <span>流程</span>
        <el-select v-model="lc" placeholder="请选择">
          <el-option label="全部" value="All"> </el-option>
          <el-option label="已调度" value="SCHEDULED"> </el-option>
          <el-option label="未调度" value="NOSCHEDULED"> </el-option>
        </el-select>
      </header>
      <section>
        <span class="vlaue">{{ lcCount }}</span>
      </section>
    </div>
    <div class="gridchild gridb">
      <header>
        <span>执行统计</span>
        <el-select v-model="condition" placeholder="请选择">
          <el-option label="12小时" value="HOUR"> </el-option>
          <el-option label="一天" value="DAY"> </el-option>
          <el-option label="一周" value="WEEK"> </el-option>
        </el-select>
      </header>
      <section>
        <div class="flex-box-ss">
          总量
          <span class="vlaue">{{ taskCount }}</span>
        </div>
        <div class="flex-box-ss">
          成功
          <span class="vlaue">{{ taskSucceeded }}</span>
        </div>
        <div class="flex-box-ss">
          失败
          <span class="vlaue">{{ taskFailed }}</span>
        </div>
      </section>
    </div>
    <div class="gridchild gridc">
      <header>
        <span>24小时任务分布（小时分布）</span>
      </header>
      <section id="chart1"></section>
    </div>
    <div class="gridchild gridd">
      <header>
        <span>周任务分布（最近7天任务分布）</span>
      </header>
      <section id="chart2"></section>
    </div>
    <div class="gridchild gride">
      <header>
        <span>失败任务分布</span>
        <el-select v-model="failedcount" placeholder="请选择">
          <el-option label="12小时" value="HOUR"> </el-option>
          <el-option label="一天" value="DAY"> </el-option>
          <el-option label="一周" value="WEEK"> </el-option>
        </el-select>
      </header>
      <section id="chart3"></section>
    </div>
    <div class="gridchild gridf">
      <header>
        <span>执行次数变化（天时间序列）</span>
      </header>
      <section id="chart4"></section>
    </div>
  </div>
</template>

<script>
import setChart from "./setChart.js";
import echarts from "echarts";

export default {
  name: "imp-count",
  data() {
    return {
      value: "",
      charts: [],
      lc: "All",
      lcCount: 0,
      condition: "HOUR",
      taskCount: 0,
      taskFailed: 0,
      taskSucceeded: 0,
      failedcount: "DAY",
      timer: ""
    };
  },
  watch: {
    condition() {
      this.taskcount();
    },
    lc() {
      this.taskcount2();
    },
    failedcount() {
      this.map3();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.charts = [1, 2, 3, 4].map(index =>
        echarts.init(document.querySelector(`#chart${index}`))
      );
      this.taskcount();
      this.taskcount2();
      this.map1();
      this.map2();
      this.map3();
      this.map4();
      window.addEventListener("resize", this.resize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
  },
  mixins: [setChart],
  methods: {
    resize() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.charts.forEach(chart => {
          chart.resize();
        });
      }, 200);
    },
    async taskcount() {
      let res = await this.$http.get(
        "/gavial/v1/task/exec/taskcount?condition=" + this.condition
      );
      if (res.data.data[0]) {
        this.taskCount = res.data.data[0].taskCount;
        this.taskFailed = res.data.data[0].taskFailed;
        this.taskSucceeded = res.data.data[0].taskSucceeded;
      }
    },
    async taskcount2() {
      let res = await this.$http.get(
        `/gavial/v1/task/view/task/exec/taskcount?condition=${this.lc}`
      );
      this.lcCount = res.data.data.count;
    },
    async map1() {
      let res = await this.$http.get(`/gavial/v1/task/exec/hourcount`);
      let datas = res.data.data;
      let time = [];
      let taskFailed = [];
      let taskSucceeded = [];
      datas.forEach(data => {
        time.push(Object.values(data)[0].time.substring(8));
        taskFailed.push(Object.values(data)[0].taskFailed);
        taskSucceeded.push(Object.values(data)[0].taskSucceeded);
      });
      this.setChart(this.charts[0], {
        series: [
          {
            type: "bar",
            stack: "a",
            name: "成功",
            data: taskSucceeded
          },
          {
            type: "bar",
            stack: "a",
            name: "失败",
            data: taskFailed
          }
        ],
        data: time
      });
    },
    async map2() {
      let res = await this.$http.get(`/gavial/v1/task/exec/weekcount`);
      let datas = res.data.data;
      let time = [];
      let taskFailed = [];
      let taskSucceeded = [];
      datas.forEach(data => {
        time.push(Object.values(data)[0].time.substring(4));
        taskFailed.push(Object.values(data)[0].taskFailed);
        taskSucceeded.push(Object.values(data)[0].taskSucceeded);
      });
      this.setChart(this.charts[1], {
        series: [
          {
            type: "bar",
            stack: "a",
            name: "成功",
            data: taskSucceeded
          },
          {
            type: "bar",
            stack: "a",
            name: "失败",
            data: taskFailed
          }
        ],
        data: time
      });
    },
    async map3() {
      let res = await this.$http.get(
        `/gavial/v1/task/exec/failedcount?condition=${this.failedcount}`
      );
      let datas = res.data.data;
      let time = [];
      let taskFailed = [];
      datas.forEach(data => {
        time.push(Object.values(data)[0].taskName);
        taskFailed.push(Object.values(data)[0].taskFailed);
      });
      this.setChart2(this.charts[2], {
        series: [
          {
            type: "bar",
            name: "次数",
            data: taskFailed
          }
        ],
        data: time
      });
    },
    async map4() {
      let res = await this.$http.get(`/gavial/v1/task/exec/allcount`);
      let datas = res.data.data;
      let time = [];
      let execCount = [];
      datas.forEach(data => {
        time.push(Object.values(data)[0].time);
        execCount.push(Object.values(data)[0].execCount);
      });
      this.setChart4(this.charts[3], {
        series: [
          {
            type: "line",
            name: "次数",
            symbolSize: 8,
            smooth: true,
            data: execCount,
            areaStyle: {
              normal: {
                color: "#73b3f2"
              }
            }
          }
        ],
        data: time
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.grida {
  grid-area: grida;
}
.gridb {
  grid-area: gridb;
}
.gridc {
  grid-area: gridc;
}
.gridd {
  grid-area: gridd;
}
.gride {
  grid-area: gride;
}
.gridf {
  grid-area: gridf;
}
#imp-count {
  height: calc(100% - var(--padding) * 2);
  padding: var(--padding);
  background: #fff;
  overflow: hidden;
  display: grid;
  grid-template-columns: repeat(7, 1fr [col-start]);
  grid-template-rows: repeat(5, 1fr [row-start]);
  grid-template-areas:
    "grida grida gridb gridb gridb gridb gridb"
    "gridc gridc gridc gridc gridd gridd gridd"
    "gridc gridc gridc gridc gridd gridd gridd"
    "gride gride gride gride gridf gridf gridf"
    "gride gride gride gride gridf gridf gridf";
  grid-gap: var(--padding);
  .gridchild {
    border: 1px solid #eef1f5;
    header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px;
      height: 50px;
      background: #eef1f5;
      & > span {
        font-size: 17px;
      }
      .el-select {
        width: 140px;
      }
    }
    section {
      height: calc(100% - 50px);
      display: flex;
      justify-content: center;
      align-items: center;
      .vlaue {
        font-size: 25px;
        margin-left: 5px;
        color: #000;
      }
      .flex-box-ss {
        height: 100%;
        flex: 1 1 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #8391a5;
        /* color:#ee9896; */
        position: relative;
      }
      .flex-box-ss ~ .flex-box-ss::before {
        content: "";
        height: 90%;
        width: 1px;
        background: #8391a5;
        background: linear-gradient(
          transparent,
          #8391a5 25%,
          #8391a5 75%,
          transparent
        );
        position: absolute;
        left: 0;
      }
    }
  }
}
</style>
